var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { BaseComponent } from "../../views/base.component";
import { EventsService } from "../../lib/EventsService";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "../../translate";
import { FilterFormService } from "../../views/filter_form/filter_form.service";
import { AccessorService } from "./accessor.service";
import { DomSanitizer } from "@angular/platform-browser";
import dictionary from "dict/static.json";
import 'selectize/dist/css/selectize.css';
import 'selectize/dist/js/standalone/selectize.min.js';
import { ModalService } from "../../views/modal/base_modal.component";
import { AccessorStatsModalComponent } from "./stats.component";
import { AccessorMyStatsModalComponent } from "./mystats.component";
import { ChartParams } from "../../views/chart/chart.component";
import { AccessorPersonalStatsModalComponent } from "./personal_stats.component";
import { AuthService } from "../../auth.service";
import { AccessorManageModalComponent } from "./manage.component";
import { AccessorSiteStatsModalComponent } from "./site_stats.component";
import { AlertComponent } from "../../views/modal/alert.component";
var AccessorComponent = /** @class */ (function (_super) {
    __extends(AccessorComponent, _super);
    function AccessorComponent(eventsService, service, activatedRoute, translate, router, filter, modalService, authService, sanitizer) {
        var _this = _super.call(this, eventsService, service, activatedRoute, filter, translate) || this;
        _this.eventsService = eventsService;
        _this.service = service;
        _this.activatedRoute = activatedRoute;
        _this.translate = translate;
        _this.router = router;
        _this.filter = filter;
        _this.modalService = modalService;
        _this.authService = authService;
        _this.sanitizer = sanitizer;
        _this.siteId = '';
        _this.url = '';
        _this.domainUrl = '';
        _this.userRoles = [];
        _this.addFilterParams = {
            dateFilters: ['dateCreated', 'datePaid', 'dateSiteCreated']
        };
        _this.editCount = 0;
        _this.deferCount = 0;
        _this.totalCount = 0;
        _this.siteCategory = '';
        _this.siteSubject = '';
        _this.topSite = false;
        _this.selectize = {
            config: {
                valueField: 'title',
                labelField: 'title',
                searchField: 'title',
                load: null
            },
            options: []
        };
        _this.iframeLoader = true;
        _this.mainLoader = true;
        _this.height = 150;
        _this.dictionary = dictionary;
        return _this;
    }
    AccessorComponent.prototype.onload = function () {
        var w = window, d = document, e = d.documentElement, g = d.getElementsByTagName('body')[0], y = w.innerHeight || e.clientHeight || g.clientHeight;
        this.height = y - 160;
    };
    AccessorComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.selectize.options = this.dictionary.accessorCategories;
                        this.userRoles = this.authService.roles;
                        return [4 /*yield*/, this.getIframeData()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.getMainData()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AccessorComponent.prototype.getConfig = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.service.getConfig().toPromise()];
                    case 1:
                        _a.config = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AccessorComponent.prototype.getIframeData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.iframeLoader = true;
                        return [4 /*yield*/, this.service.getIframeInfo().toPromise()];
                    case 1:
                        data = _a.sent();
                        this.siteId = data.siteId;
                        this.url = data.url;
                        this.domainUrl = data.domainUrl;
                        this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl("https://ukit.com/preview/" + this.url + "/index");
                        this.iframeLoader = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    AccessorComponent.prototype.getMainData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.mainLoader = true;
                        return [4 /*yield*/, this.service.getMainInfo(this.filter.filterParams).toPromise()];
                    case 1:
                        data = _a.sent();
                        this.editCount = data.editCount;
                        this.deferCount = data.deferCount;
                        this.totalCount = data.totalCount;
                        this.mainLoader = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    AccessorComponent.prototype.setCategory = function (defer) {
        return __awaiter(this, void 0, void 0, function () {
            var check, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.checkSite({ siteId: this.siteId }).toPromise()];
                    case 1:
                        check = _a.sent();
                        if (check.status == 'error') {
                            this.modalService.open(AlertComponent, {
                                title: 'ERROR',
                                message: this.translate.__A('support.accessor.site is editing now')
                            });
                            return [2 /*return*/, true];
                        }
                        if (defer == 0 && (this.siteSubject == '' || this.siteCategory == '')) {
                            this.modalService.open(AlertComponent, {
                                title: 'ERROR',
                                message: this.translate.__A('support.accessor.set category or defer')
                            });
                            return [2 /*return*/, true];
                        }
                        data = {
                            siteId: this.siteId,
                            category: this.siteCategory,
                            subject: this.siteSubject,
                            defer: defer,
                            top: this.topSite
                        };
                        return [4 /*yield*/, this.service.setCategory(data).toPromise()];
                    case 2:
                        _a.sent();
                        this.topSite = false;
                        this.siteCategory = '';
                        this.siteSubject = '';
                        this.selectizeTitle = '';
                        if (defer) {
                            this.deferCount++;
                        }
                        else {
                            this.editCount++;
                        }
                        this.totalCount--;
                        return [4 /*yield*/, this.getIframeData()];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AccessorComponent.prototype.showDetails = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, modalRef, stats;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        modalRef = this.modalService.open(AccessorStatsModalComponent, {
                            title: this.translate.__A('support.accessor.stats'),
                        }, { size: 'hg' });
                        modalRef.componentInstance.chart = new ChartParams();
                        modalRef.componentInstance.chart.showLoader();
                        return [4 /*yield*/, this.service.getStats({}).toPromise()];
                    case 1:
                        stats = (_a.sent()).stats;
                        modalRef.componentInstance.chart.data = stats.reduce(function (accessors, accessor) {
                            accessors.push([
                                accessor.email,
                                accessor.totalCount
                            ]);
                            return accessors;
                        }, []);
                        modalRef.componentInstance.stats = stats;
                        modalRef.componentInstance.chart.setOptions({
                            type: 'pie',
                            onclick: function (e) {
                                return __awaiter(this, void 0, void 0, function () {
                                    var subModalRef, options, stats;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                subModalRef = me.modalService.open(AccessorPersonalStatsModalComponent, {
                                                    title: e.name,
                                                    email: e.name
                                                }, { size: 'hg' });
                                                options = { accessorEmail: e.name, dateFilter: me.filter.filterParams.accessorDateFilter.type, start: me.filter.filterParams.accessorDateFilter.start, end: me.filter.filterParams.accessorDateFilter.end };
                                                return [4 /*yield*/, me.service.getPersonalStats(options).toPromise()];
                                            case 1:
                                                stats = (_a.sent()).stats;
                                                subModalRef.componentInstance.stats = stats;
                                                return [2 /*return*/];
                                        }
                                    });
                                });
                            }
                        });
                        modalRef.componentInstance.chart.hideLoader();
                        return [2 /*return*/];
                }
            });
        });
    };
    AccessorComponent.prototype.showMyEditSites = function (type) {
        return __awaiter(this, void 0, void 0, function () {
            var modalRef, stats;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        modalRef = this.modalService.open(AccessorMyStatsModalComponent, {
                            title: this.translate.__A("support.accessor." + (type == 'edit' ? 'viewed' : 'defer') + " by me"),
                            mark: type
                        }, { size: 'hg' });
                        return [4 /*yield*/, this.service.getMyStats({ mark: type }).toPromise()];
                    case 1:
                        stats = (_a.sent()).stats;
                        modalRef.componentInstance.stats = stats;
                        modalRef.componentInstance.getIframeData.subscribe(function ($event) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, this.getIframeData()];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        }); }); });
                        return [2 /*return*/];
                }
            });
        });
    };
    AccessorComponent.prototype.manage = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getConfig()];
                    case 1:
                        _a.sent();
                        this.modalService.open(AccessorManageModalComponent, {
                            title: this.translate.__A('common.Manage'),
                            config: this.config,
                        }, { size: 'hg' });
                        return [2 /*return*/];
                }
            });
        });
    };
    AccessorComponent.prototype.siteSearch = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.modalService.open(AccessorSiteStatsModalComponent, {
                    title: this.translate.__A('support.accessor.site search'),
                }, { size: 'hg' });
                return [2 /*return*/];
            });
        });
    };
    AccessorComponent.prototype.changeSiteCategory = function ($event) {
        if ($event == '')
            return true;
        var data = $event.split(' - ');
        this.siteCategory = data[0];
        this.siteSubject = data[1];
    };
    return AccessorComponent;
}(BaseComponent));
export { AccessorComponent };
